import React from "react";
import { Dialog } from "primereact/dialog";
import { useNavigate, useParams } from "react-router-dom";
import { resetRegData } from "../../directors-form/directorsRegFormSlice";
import { useDispatch } from "react-redux";

const DeleteDialog = ({
  visible,
  onHide,
  onConfirm,
  rowToDelete,
  leave,
  cancelAppointment,
  entityId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const confirmLeave = () => {
    navigate("/");
  };

  const handleCancelRoute = () => {
    navigate(`/entity/${entityId}/directors`);
    dispatch(resetRegData());
  };
  return (
    <Dialog visible={visible} className="edit-contact-dialog" onHide={onHide}>
      <p className="del-dialog-heading">
        {leave
          ? "Are you sure you want to leave?"
          : cancelAppointment
            ? "Are you sure you want to cancel this appointment?"
            : `Are you sure you want to delete ${rowToDelete?.preferred_name || [rowToDelete?.name, rowToDelete?.other_name, rowToDelete?.last_name].filter(Boolean).join(" ")}?`}
      </p>

      <p className="del-dialog-para">
        {leave
          ? "If you leave now, your changes won't be saved. Would you like to continue without saving or go back to finish setting up?"
          : cancelAppointment
            ? "Canceling will permanently remove the information you have added. This action cannot be undone. Do you want to proceed?"
            : ` Deleting ${rowToDelete?.preferred_name || [rowToDelete?.name, rowToDelete?.other_name, rowToDelete?.last_name].filter(Boolean).join(" ")} will permanently remove their information from
        your records. This action cannot be undone. Do you want to proceed?`}
      </p>
      <div className="flex justify-content-end gap-2 mt-4">
        <button className="cancel-btns" onClick={onHide}>
          Cancel
        </button>
        {leave ? (
          <button className="confirm-btn" onClick={confirmLeave}>
            Yes, leave
          </button>
        ) : cancelAppointment ? (
          <button className="confirm-btn" onClick={handleCancelRoute}>
            Yes, Cancel
          </button>
        ) : (
          <button className="confirm-btn" onClick={onConfirm}>
            Yes, delete
          </button>
        )}
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
